<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <!-- <div class="header" v-if="!loading">
      <img v-on:click="back()" :src="icon" class="icon" />
      <p class="title">SIGN UP</p>
    </div>-->
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["signup"] }}</p>
      </div>
      <div class="content_title">
        <p v-if="!showCodeInput">
          {{ this.$store.getters.TRANSLATIONS["please_enter_your_info"] }}
        </p>
        <p v-if="showCodeInput">
          {{ this.$store.getters.TRANSLATIONS["please_enter_the_code"] }}
        </p>
      </div>
      <form autocomplete="off">
        <input
          type="text"
          v-model="firstName"
          :placeholder="this.$store.getters.TRANSLATIONS['first_name']"
          class="firstName"
          autocomplete="off"
          v-if="!config.privateSignUp"
        />
        <input
          type="text"
          v-model="lastName"
          :placeholder="this.$store.getters.TRANSLATIONS['last_name']"
          class="lastName"
          autocomplete="off"
          v-if="!config.privateSignUp"
        />
        <input
          type="text"
          v-model="email"
          :placeholder="this.$store.getters.TRANSLATIONS['email']"
          class="email"
          autocomplete="off"
          v-if="!config.privateSignUp"
        />
        <!-- <input
          type="tel"
          v-mask="['+1 (###) ###-####']"
          v-model="telephone"
          placeholder="Phone"
          class="phone"
          autocomplete="off"
        />-->
        <input
          type="tel"
          v-model="telephone"
          :placeholder="this.$store.getters.TRANSLATIONS['phone']"
          class="phone"
          autocomplete="off"
          v-if="!showCodeInput"
        />
        <input
          type="password"
          v-model="password"
          :placeholder="this.$store.getters.TRANSLATIONS['password']"
          class="password"
          autocomplete="new-password"
          v-if="!config.privateSignUp"
        />
        <input
          type="password"
          v-model="passwordConfirm"
          :placeholder="this.$store.getters.TRANSLATIONS['password_confirm']"
          class="password"
          autocomplete="new-password"
          v-if="!config.privateSignUp"
        />
        <input
          type="text"
          v-model="code"
          :placeholder="this.$store.getters.TRANSLATIONS['code']"
          class="code"
          autocomplete="off"
          v-if="config.privateSignUp && showCodeInput"
        />
        <div class="agree" v-if="!showCodeInput">
          <div class="agree-checkbox">
            <input type="checkbox" v-model="agree" />
          </div>
          <div class="agree-text">
            <span class="g-text">
              {{ this.$store.getters.TRANSLATIONS["i_have_read_and_agree"] }}
              <a v-on:click="showAgreementPopup = true" href="#/signUp"
                >{{ this.$store.getters.TRANSLATIONS["terms"] }} &amp;
                {{ this.$store.getters.TRANSLATIONS["conditions"] }}</a
              >
            </span>
          </div>
        </div>
      </form>
      <div
        class="agreement"
        v-if="
          showAgreementPopup &&
          !agree &&
          !showCodeInput &&
          this.$store.getters.SELECTED_LANGUAGE == 'en'
        "
        disabled
        @scroll="onScroll"
      >
        Registration Agreement
        <br />
        <br />Parkenda Express Valet Parking Program Please Read Carefully and,
        if you agree, click checkbox above
        <br />
        <br />I, the Participant, ("I", "me", "my", etc.) desire to participate
        in the Parkenda Express Valet Parking Program (the "Program") that is
        offered by The West Egg Group Corp. ("TWEGCO"), a corporation organized
        under the laws of the province of Ontario (TWEGCO and I may be referred
        to as a "Party" or together, the "Parties"). In exchange for the ability
        to participate in the Program and subsequent and recurring procurement
        of valet parking services from TWEGCO (“Services”), and other good and
        valuable consideration, the receipt of which is hereby acknowledged, I
        hereby irrevocably and unconditionally covenant and agree for myself and
        my heirs, executors, insurers, successors and assigns as follows:
        <br />
        <br />1. Purpose. I have been informed that in order for me to
        participate in the Program, TWEGCO will affix a label on which is
        displayed barcode and/or QR code (the “Label”) to the driver’s door jamb
        of my vehicle (the “Vehicle”).
        <br />
        <br />2. Representation. I represent and warrant that the information
        provided above is accurate in all material respects and that I am the
        owner or lessor of the Vehicle. I hereby represent and warrant that the
        Vehicle is in good working condition, safe to operate, duly registered
        and fully insured. I acknowledge and understand that TWEGCO will rely on
        the accuracy of the foregoing representation and warranty when it takes
        possession and operates the Vehicle in conjunction with the delivery of
        Services.
        <br />
        <br />3. Release from Liability and Covenant Not to Sue. I FULLY AND
        FOREVER RELEASE AND DISCHARGE GATSBY AND ITS PARENT, SUBSIDIARIES,
        AFFILIATES, SERVICE PROVIDERS AND THEIR RESPECTIVE DIRECTORS, OFFICERS,
        EMPLOYEES, CONTRACTORS, AGENTS AND REPRESENTATIVES (EACH, A "RELEASED
        PARTY" AND, COLLECTIVELY, "RELEASED PARTIES") FROM ANY AND ALL INJURIES,
        LOSSES, DAMAGES, CLAIMS (INCLUDING BUT NOT LIMITED TO NEGLIGENCE
        CLAIMS), DEMANDS, LAWSUITS, EXPENSES, COSTS, AND ANY OTHER LIABILITY OF
        ANY KIND, OF OR TO ME, MY PROPERTY, OR ANY OTHER PERSON, DIRECTLY OR
        INDIRECTLY ARISING OUT OF OR IN CONNECTION WITH MY PARTICIPATION IN THE
        PROGRAM, EVEN IF IT IS DUE TO THE NEGLIGENCE, INJUDICIOUS ACT, OMISSION
        OR OTHER FAULT OF A RELEASED PARTY. I COVENANT NOT TO MAKE OR BRING ANY
        SUCH CLAIM AGAINST GATSBY OR ANY OTHER RELEASED PARTY, AND FOREVER
        RELEASE AND DISCHARGE GATSBY AND ALL OTHER RELEASED PARTIES FROM
        LIABILITY UNDER SUCH CLAIMS.
        <br />
        <br />4. Indemnification. I AGREE TO INDEMNIFY AND HOLD HARMLESS GATSBY
        AND THE OTHER RELEASED PARTIES FROM AND AGAINST ANY AND ALL LOSSES,
        EXPENSES, CLAIMS, DAMAGES, DEMANDS, LIABILITIES, DEFICIENCIES, COSTS,
        FINES, PENALTIES, INTEREST AND EXPENSES, INCLUDING BUT NOT LIMITED TO
        REASONABLE LEGAL FEES, ARISING FROM OR RELATING TO ANY MISREPRESENTATION
        I MAY MAKE OR TO THE UNSAFE CONDITION OF MY VEHICLE. I shall cooperate
        in the defence of any claim. I acknowledge that TWEGCO retains the
        right, to assume the exclusive defence and control of any third party
        claim subject to indemnification under this agreement using counsel of
        its own choice.
        <br />
        <br />5. Insurance. I understand that I am solely responsible for
        ensuring that the Vehicle is adequately insured and duly registered.
        <br />
        <br />6. Ownership. I understand that all Labels that may be affixed to
        the Vehicle remain the exclusive property of TWEGCO both during and
        after my participation in the Program and any information associated
        with such Label will also be and remain the sole and exclusive property
        of TWEGCO. Upon termination of this agreement, I will remove at my sole
        cost any such Label. Likewise, in the event I cease to be the owner or
        lessor of the Vehicle, prior to relinquishing possession of same to any
        third party, I will remove at my sole cost any such Label. Any label
        that is removed must immediately either be returned to TWEGCO or
        permanently destroyed by me, the Participant, as directed by TWEGCO in
        its sole discretion.
        <br />
        <br />7. Authorization to Use Personal Information. I agree that TWEGCO
        and others may use the information I provide in conjunction with the
        Program as well as information collected in terms of my participation in
        the Program and use of related services for any of the following
        purposes: (i) management of the Program and my participation in the
        Program and procurement of services from TWEGCO; (ii) performance of
        services that I procure from TWEGCO in conjunction with the Program; and
        (iii) delivery of advertisements and promotional materials relating to
        TWEGCO and the services that it offers or to those of third parties that
        TWEGCO believes may be of interest to me. The foregoing is in addition
        to the other consents, permissions and authorizations that are provided
        or deemed to be provided in TWEGCO’s privacy policy accessible at
        <a href="http://www.parkenda.com/tc/privacy-policy.html" target="_blank"
          >Policy</a
        >
        (the “Privacy Policy”) (the practices, uses, processes and events
        described in this Section 7 are collectively referred to as “Permitted
        Uses”).
        <br />
        <br />8. Consent to Receipt of Commercial Electronic Messages. I hereby
        agree that TWEGCO as well as its parent, affiliates and subsidiaries,
        may communicate with me by e-mail, text messages, SMS, MMS, tweets or
        through any other electronic medium for the purposes of or in relation
        with any Permitted Uses and I WAIVE ANY CLAIM (INCLUDING, WITHOUT
        LIMITATION, CLAIMS BASED ON INVASION OF PRIVACY, INTRUSION UPON
        SECLUSION, DEFAMATION AND RIGHT OF PUBLICITY) OR PURPORTED VIOLATION OF
        ANY ANTI-SPAM OR SIMILAR LAW.
        <br />
        <br />9. Privacy Statement. I acknowledge that whatever information I
        provided to TWEGCO in connection with my participation in the Program or
        that is otherwise obtained, collected or generated by TWEGCO in
        conjunction with my participation in the Program (including, without
        limitation, the procurement of Services), is subject to Section 7 of
        this agreement as well as the Privacy Policy.
        <br />
        <br />10. Procurement of Services. Procurement of Services will be
        subject to TWEGCO’s terms and conditions that are in effect at the time
        of such purported procurement. For clarity, TWEGCO may change such terms
        and conditions at any time and from time to time in its sole discretion.
        <br />
        <br />11. Choice of Law. This agreement and all related documents
        including all schedules attached hereto and other documents incorporated
        by reference, and all matters arising out of or relating to the Program
        and/or this agreement, whether sounding in contract, tort, or statute,
        are governed by, and construed in accordance with, the laws of the
        province of Ontario, Canada and the federal laws of Canada applicable
        therein[, without giving effect to any choice or conflict of law
        provision or rule (whether of the province of Ontario or any other
        jurisdiction) that would cause the application of the laws of any
        jurisdiction other than those of the province of Ontario.
        <br />
        <br />12. Choice of Forum. Any legal suit, action, litigation or
        proceeding of any kind whatsoever in any way arising out of, from or
        relating to this agreement, including all exhibits, schedules,
        attachments, and appendices attached to this agreement, and all
        contemplated transactions, shall be instituted in the courts of the
        province of Ontario located in the city of Toronto, Ontario, Canada, and
        each Party irrevocably submits to the exclusive jurisdiction of such
        courts in any such suit, action, litigation or proceeding. Service of
        process, summons, notice or other document by mail to such Party's
        address set forth herein shall be effective service of process for any
        suit, action, litigation or other proceeding brought in any such court.
        Each Party agrees that a final judgment in any such suit, action,
        litigation, or proceeding is conclusive and may be enforced in other
        jurisdictions by suit on the judgment or in any other manner provided by
        law. The Parties irrevocably and unconditionally waive any objection to
        the venue of any action or proceeding in such courts and irrevocably
        waive and agree not to plead or claim in any such court that any such
        action or proceeding brought in any such court has been brought in an
        inconvenient forum.
        <br />
        <br />13. Withdrawal. I can withdraw from the Program and terminate this
        agreement at any time by providing written notice to TWEGCO. Likewise,
        TWEGCO may in its sole discretion and at any time cancel the Program or
        my participation in the Program (and this agreement) by providing
        written notice to me. Sections 2, 3, 4, 6, 7(iii), 8, 9 11, 12, 13 and
        14 of this agreement will survive withdrawal from the Program,
        cancellation of the Program, cancellation of my participation in the
        Program and termination of this agreement.
        <br />
        <br />14. Miscellaneous. If any provision of this agreement is illegal
        or unenforceable under applicable law, the remainder of the provision
        will be amended to achieve as closely as possible the effect of the
        original term, and all other provisions of this agreement will continue
        in full force and effect. This agreement supersedes any oral or written
        statements made by or to me in connection with the Program. This
        agreement may not be modified except by a written agreement that
        specifically refers to the provision or provisions to be amended and
        that is signed by an authorized representative of TWEGCO, following
        review by TWEGCO's legal department or external legal counsel. I am not
        in a joint venture with TWEGCO or any other Released Party. I understand
        that my participation in the Program does not form an employment
        relationship between me and TWEGCO or any other Released Party.
        <br />
        <br />15. Informed Consent. By clicking on the checkbox above, I hereby
        certify that I: <br />(a) am at least 18 years of age; <br />(b) have
        read and fully understand the above information, terms and conditions;
        <br />(c) voluntarily agree to participate in the Program, in good
        faith.
        <br />
        <br />I hereby agree to receive commercial electronic communications
        from The West Egg Group Corp. as detailed in Sections 7 and 8 above.
      </div>
      <div
        class="agreement"
        v-if="
          showAgreementPopup &&
          !agree &&
          !showCodeInput &&
          this.$store.getters.SELECTED_LANGUAGE == 'fr'
        "
        disabled
        @scroll="onScroll"
      >
        Contrat D'inscription
        <br />
        <br />Parkenda Express Valet Parking Program Veuillez lire attentivement
        et, si vous êtes d'accord, cochez la case ci-dessus
        <br />
        <br />Je, le Participant, ("je", "moi", "mon", etc.) souhaite participer
        dans le programme Parkenda Express Valet Parking (le « Programme ») qui
        est offert par The West Egg Group Corp. (« TWEGCO »), une société
        organisée en vertu des lois de la province de l'Ontario (TWEGCO et moi
        pouvons être référés en tant que "Partie" ou ensemble, les "Parties").
        En échange de la capacité participer au programme et aux achats
        ultérieurs et récurrents des services de voiturier de TWEGCO
        ("Services"), et d'autres biens et contrepartie de valeur, dont la
        réception est accusée par la présente, je par la présente,
        irrévocablement et inconditionnellement, m'engager et convenir pour
        moi-même et mes héritiers, exécuteurs testamentaires, assureurs,
        successeurs et ayants droit comme suit:
        <br />
        <br />...
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="back()" class="button back_button">
        {{ this.$store.getters.TRANSLATIONS["back"] }}
      </button>
      <button
        v-on:click="signUp()"
        :disabled="!agree"
        v-if="!config.privateSignUp"
        class="button next_button"
      >
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
      <button
        v-on:click="beforeSignUp()"
        :disabled="!agree"
        v-if="config.privateSignUp && !showCodeVerification"
        class="button next_button"
      >
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
      <button
        v-on:click="validateCode()"
        class="button next_button"
        v-if="config.privateSignUp && showCodeVerification"
      >
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      loading: false,
      showAgreementPopup: false,
      enableCheckBox: false,
      firstName: "",
      lastName: "",
      email: "",
      agree: false,
      telephone: this.$route.query.phone || "",
      code: "",
      password: "",
      passwordConfirm: "",
      showCodeInput: false,
      showCodeVerification: false,
      onScroll: ({ target: { scrollTop, clientHeight, scrollHeight } }) => {
        if (scrollTop + clientHeight >= scrollHeight) {
          this.enableCheckBox = true;
        }
      },
      validateCode() {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/9620CC2286084920BB6D349BBB34F1F6`, {
            telephone: this.telephone,
            code: this.code
          })
          .then((response) => {
            if (response.status === 200) {
              this.signUp();
            } else {
              throw "Not valid code. Try again";
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["not_valid_code"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$modal.hide("dialog");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      beforeSignUp() {
        const error = this.$store.getters.TRANSLATIONS["can_not_send_sms"];
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.code = "";
        this.$http
          .post(`${process.env.SERVER_URL}/1D9F3BD707844CB39E301D6D5819648F`, {
            telephone: this.telephone
          })
          .then((response) => {
            console.log(response);
            this.loading = false;
            if (response.status === 200) {
              this.showCodeInput = true;
              this.showCodeVerification = true;
            } else {
              throw error;
            }
          })
          .catch((e) => {
            this.$modal.show("dialog", {
              text: error,
              buttons: [
                {
                  title: "OK"
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      signUp: () => {
        let error;
        if (this.config.privateSignUp) {
          const userTimeStamp = Date.now().toString();
          this.firstName = `00000user_${userTimeStamp}_firstName`;
          this.lastName = `00000user_${userTimeStamp}_lastName`;
          this.email = `00000${userTimeStamp}@parkenda.com`;
          this.password = this.telephone;
          this.passwordConfirm = this.telephone;
          if (!this.telephone) {
            error = this.$store.getters.TRANSLATIONS["phone_empty"];
          }
        } else {
          if (!this.firstName) {
            error = this.$store.getters.TRANSLATIONS["first_name_empty"];
          }
          if (!this.lastName) {
            error = this.$store.getters.TRANSLATIONS["last_name_empty"];
          }
          if (!this.validateEmail(this.email)) {
            error = this.$store.getters.TRANSLATIONS["not_valid_email"];
          }
          if (this.password.length < 6) {
            error = this.$store.getters.TRANSLATIONS["password_length"];
          }
          if (!this.telephone) {
            error = this.$store.getters.TRANSLATIONS["phone_empty"];
          }
          if (this.password !== this.passwordConfirm) {
            error = this.$store.getters.TRANSLATIONS["passwords_do_not_match"];
          }
        }

        if (error) {
          this.$modal.show("dialog", {
            text: error,
            buttons: [
              {
                title: "OK"
              }
            ]
          });
        } else {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$http
            .post(
              `${process.env.SERVER_URL}/26D97EB2EF3A4AE79E4ADC56A8880FCE`,
              {
                firstName: this.firstName,
                lastName: this.lastName,
                telephone: this.telephone,
                password: this.password,
                email: this.email,
                flagActive: true,
                customerType: "CSM",
                source: this.$route.query.source || "parkenda-web",
                sourceLocationId: this.$route.query.sourceLocationId || "",
                isPrivate: this.config.privateSignUp
              }
            )
            .then((response) => {
              console.log("SignUp response");
              console.log(response);
              this.$store.dispatch("SAVE_TOKEN", response.data.token);
              this.$storage.set("parkendaToken", response.data.token);
            })
            .then(() => {
              return this.$http
                .get(
                  `${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`,
                  {
                    headers: {
                      "x-access-token": this.$storage.get("parkendaToken")
                    }
                  }
                )
                .then((response) => {
                  console.log("Get current user response");
                  console.log(response);
                  this.$store.dispatch("SAVE_USER", response.data);
                  this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", false);
                  this.$router.push("/addCard");
                });
            })
            .catch((error) => {
              let text = this.$store.getters.TRANSLATIONS["signup_failed"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                text = error.response.data.message;
              }
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK"
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
            });
        }
      },
      back: () => {
        if (this.config.privateSignUp && this.showCodeVerification) {
          this.showCodeVerification = false;
          this.showCodeInput = false;
        } else {
          this.$router.push("/");
        }
      },
      icon: require("@/assets/icon_back.png")
    };
  },
  methods: {
    validateEmail: (email) => {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
form input {
  margin: 5vh 17vw 0px;
  width: 65%;
  float: left;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
form input::placeholder {
  color: rgba(114, 174, 255, 1);
}
.back_button {
  background-color: white;
  color: #fbae31;
}
.next_button:disabled {
  display: none;
}
.agreement {
  margin: 0 17vw;
  margin-top: 10px;
  font-size: 1.65vh;
  text-align: left;
  height: 25vh;
  padding: 5px;
  background-color: #f7f7f7;
  border: none;
  resize: none;
  overflow: scroll;
}
.agree-checkbox {
  width: 7%;
  margin: auto 0;
}
.agree-checkbox input {
  margin: 0 0 0 0;
  background: transparent;
}
.agree {
  width: 79%;
  margin: 3vh 0 0 51px;
  display: inline-flex;
}
.agree-text {
  font-size: 12px;
}
.g-text {
  color: white;
}
.g-text a {
  color: rgba(251, 174, 49, 1);
}
.button {
  font-size: 2vh;
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue